import { useEffect, useState } from 'react';
import Talk from 'talkjs';
import useLoggedInUser from '@rsos/hooks/useLoggedInUser';
import { useSelectedTextFrom911ConversationID } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Selectors';
import { captureException } from '@rsos/utils/sentry';
import { createTalkSession } from '@rsos/utils/talkJS';

export function useChatNotifications(callerID: string) {
  const [numberOfMessages, setNumberOfMessages] = useState(0);

  const loggedInUser = useLoggedInUser('rsp_calls_user');

  const conversationID: string | undefined =
    useSelectedTextFrom911ConversationID(callerID);

  useEffect(() => {
    async function handleTalkJsSession() {
      const session: Talk.Session = await createTalkSession(loggedInUser);

      return session.onMessage(message => {
        const isFromOpenedCall = message.conversation.id === conversationID;
        if (isFromOpenedCall) {
          setNumberOfMessages(currentNumber => {
            return currentNumber + 1;
          });
        }
      });
    }

    const subscriptionPromise = handleTalkJsSession().catch(error => {
      captureException(error);
    });

    return () => {
      subscriptionPromise.then(subscription => {
        subscription?.unsubscribe();
      });
    };
  }, [loggedInUser, conversationID]);

  return {
    numberOfMessages,
  };
}
